import api from './api'

export const productService = {
  // Obtener todos los productos
  getProducts: async (params = {}) => {
    const response = await api.get('/products', { params })
    return response.data
  },

  // Obtener producto por ID
  getProductById: async (id) => {
    const response = await api.get(`/products/${id}`)
    return response.data
  },

  // Obtener productos por categoría
  getProductsByCategory: async (categoryName, params = {}) => {
    const response = await api.get(`/products/category/${encodeURIComponent(categoryName)}`, { params })
    return response.data
  },

  // Obtener productos aleatorios para "Lo más vendido"
  getRandomProducts: async (limit = 3, params = {}) => {
    const response = await api.get(`/products/random/${limit}`, { params })
    return response.data
  }
}

export default productService